import styled from 'styled-components/macro'

// Trigger wrapper. Carries the `className` from the `styled(ToolTip)` call sites and
// gives Mantine the single element child it requires, so it stays presentation-free.
// The bubble's own styling lives in ./index.tsx — Mantine renders it in a portal, so
// it can no longer be reached by descendant selectors from here.
export const StyledToolTip = styled.div``
